import { useState } from 'react'
import { useEffect } from 'react';
import {
    Grid,
    Button,
    Box,
    Table,
    TableBody,
    TableContainer,
    TableRow,
    TableHead,
    Paper,
    TableCell,
    Alert,
    Typography,
    Divider
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import { downloadBatchReport, getProjectBatches } from '../../../../../actions/rof-burns/rof-actions';

export const BatchReports = () => {
    const dispatch = useDispatch();
    const items = [
        'Batch Reports',
    ];
    const batches = useSelector(state => state.rofBurnsReducer.projectBatches)?.batches;
    const [loadingRowKey, setLoadingRowKey] = useState(null);
    const [active, setActive] = useState('Batch Reports');
    const { selectedProject } = useSelector(state => state.postFormData);
    let { id } = selectedProject || {} //measureType
    const projectKey = id

    useEffect(() => {
        dispatch(getProjectBatches(projectKey));
    }, [dispatch, projectKey]);

    const handleReportDownload = async (event, projectKey, batchKey) => {
        event.preventDefault();
        setLoadingRowKey(batchKey)
        await dispatch(downloadBatchReport(projectKey, batchKey))
            .then(() => setLoadingRowKey(null))
            .then(() => dispatch(getProjectBatches(projectKey)))
    }

    return (
        <Grid container>
            <Grid item xs={12} sx={{ pb: 3 }}>
                {items.map((item, index) => (
                    <Button
                        key={index}
                        onClick={() => setActive(item)}
                        variant={active === item ? 'contained' : null}
                    >
                        {item}
                    </Button>
                ))}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} sx={{ p: 2 }}>
                {active === 'Batch Reports' &&
                    <>
                        <Box sx={{ pb: 2 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>Batch Reports</Typography>
                            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                                <Table aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">
                                                Batch
                                            </TableCell>
                                            <TableCell align="left">
                                                Download
                                            </TableCell>
                                            <TableCell align="left">
                                            </TableCell>
                                            <TableCell align="left">
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {batches?.map((batch, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell align="left">
                                                        {batch.batch_id}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {loadingRowKey === batch.id ? <CircularProgress /> : <Button
                                                            sx={{ mt: 2 }}
                                                            variant='contained'
                                                            disabled={false}
                                                            onClick={(e) => handleReportDownload(e, projectKey, batch.id)}
                                                        >
                                                            Download Report
                                                        </Button>}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        <Alert severity='info' sx={{ width: 'fit-content' }}>Please be patient during downloads, reports are generated as a pdf and can take up to 5 minutes to complete</Alert>
                    </>
                }
            </Grid>
        </Grid >
    )
}
